<div class="wrapper" *ngIf="isAuthenticated  &&  !isUserNotValid">
  <app-header class="header" (menuClicked)="sidenav.toggle()" (translateSite)="translateSite($event)"
    [languageOptions]="translate.getLangs()" [role]="role" [isAdmin]="isAdmin" [user]="utenteLoggato">
  </app-header>

  <div class="layout">

    <app-sidebar class="sidebar" [permissions]="permissions">
      <ng-container >
      <div class="breadcrumb" *ngIf="myBreadcrumbData?.length > 0 && !isAdmin">
        <ds-breadcrumb class="breadcrumbClass" [dataCrumbs]="myBreadcrumbData" #breadcrumb
          [attr.meatball-aria-label]="'breadcrumb.MostraLivelliLabel' | translate"
          (onClickLink)='routerLinkHandler($event)'></ds-breadcrumb>
          </div>
      </ng-container>

      <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
      <app-footer></app-footer>
    </app-sidebar>
  </div>
</div>


<router-outlet *ngIf="isUserNotValid"></router-outlet>

<ds-spinner class="init-spinner" *ngIf="!isAuthenticated && !isUserNotValid" [attr.spinner-ui-variant]='"spinner"'  [attr.spinner-aria-label]= "'Caricamento' | translate"></ds-spinner>

<div class="spinner-backdrop" *ngIf="isSpinnerLoaded">
  <ds-spinner class="global-spinner" [attr.spinner-ui-variant]='"spinner"' [attr.spinner-aria-label]= "'Caricamento' | translate"></ds-spinner>
</div>